import MDSpinner from "react-md-spinner";
import React from "react";
import PropTypes from "prop-types";

export const LoadingView = (props) => {
    return props.isBusy ? <div className="text-center" style={{padding: 10}}>
        <MDSpinner size={props.spinnerSize}/>
        <p>{props.message}</p>
    </div> : props.children;

};


LoadingView.propTypes = {
    message: PropTypes.string,
    isBusy: PropTypes.bool,
    spinnerSize: PropTypes.number
};

LoadingView.defaultProps = {
    message: "Please hold on...",
    spinnerSize: 45
};



// WEBPACK FOOTER //
// ./src/components/TractorRequestBuilder/LoadingView.js